
export enum SignatureState {
    READY_TO_SIGN,
    NOT_FOUND,
    SIGNATURE_REFUSED,
    SIGNATURE_CANCELED,
    SIGNATURE_EXPIRED,
    ERROR,
    SIGNED
}
